import React, { Fragment, useMemo } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';

import { BetCount, BetStatus, Icon } from 'components';
import globalMsgs from 'messages';
import Sidebar from '../Sidebar';
import useSidebarToggler from './useSidebarToggler';
import useSidebarTogglerMob from './useSidebarTogglerMob';

import arrowLeft from 'assets/svg/arrow-left.svg';
import './sidebarTogglerMob.scss';

const SidebarTogglerMob: React.FC = () => {
    const { formatMessage } = useIntl();
    const {
        handleCloseSidebar,
        handleOpenSidebar,
        isSidebarOpen,
        isFullScreen,
        isAuthorized,
        isMedium,
    } = useSidebarToggler();
    const {
        betsSize,
        totalOdd,
        betStatus,
        shouldHideSidebar,
        refContainer,
    } = useSidebarTogglerMob();

    const formattedOdd = totalOdd?.component;

    const renderCloseBtn = useMemo(
        () => (
            <div styleName="close-btn" onClick={handleCloseSidebar}>
                <div styleName="close-text">
                    {formatMessage(globalMsgs.hide)}
                </div>
                <Icon glyph={arrowLeft} styleName="close-icon" />
            </div>
        ),
        [handleCloseSidebar, formatMessage]
    );

    const renderBetslipInfo = useMemo(() => {
        if (betsSize === 0) return formatMessage(globalMsgs.bettingSlip);

        return (
            <div styleName="betslip-info">
                <BetCount betsSize={betsSize} />
                {formattedOdd && (
                    <div styleName="total-odd">
                        {formatMessage(globalMsgs.totalOdd)} {formattedOdd}
                    </div>
                )}
            </div>
        );
    }, [formattedOdd, betsSize, formatMessage]);

    if ((isFullScreen && isMedium) || shouldHideSidebar) return null;

    return (
        <div
            styleName={cn('container', { 'is-full-screen': isFullScreen })}
            ref={refContainer}
        >
            {isSidebarOpen || (isFullScreen && !isMedium) ? (
                <Sidebar
                    isAuthorized={isAuthorized}
                    extraTab={isFullScreen ? <Fragment /> : renderCloseBtn}
                />
            ) : (
                <div styleName="open-btn" onClick={handleOpenSidebar}>
                    {renderBetslipInfo}
                    <Icon glyph={arrowLeft} styleName="icon" />
                    <BetStatus betStatus={betStatus} />
                </div>
            )}
        </div>
    );
};

export default SidebarTogglerMob;
